import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputNumber from './InputNumber';

class InputCnpj extends AbstractComponent {                  
    render() {
        return (
            <InputNumber
                md={this.props.md}
                xs={this.props.xs}
                sm={this.props.sm}
                lg={this.props.lg}
                id={this.props.id}
                style={this.props.style}
                nome={this.props.nome}                
                classNameInput="background-transparent"  
                ref={ref => this.nome = ref}                                        
                value={this.props.value}
                defaultFoco={this.props.defaultFoco}   
                defaultValue={this.props.defaultValue}
                erro={this.props.erro}
                maxLength={14}
                onChange={e => this.props.onChange(e)}
                onKeyPress={e => this.props.onKeyPress(e)}>
                CNPJ
            </InputNumber>        
        )
    }
}

InputCnpj.defaultProps = {
    md: 12,
    type: 'text',
    defaultFoco: false
};

export default InputCnpj;